export const FETCH_PROJECTS = 'FETCH_PROJECTS'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_SELECT = 'SET_SELECT'
export const FETCH_PROJECT_LIST_ACTION = 'getProjectList'
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS'
